export const setSound = ({ commit }, val = false) => {
  commit('setSound', val);
};

export const setScore = ({ commit }, value) => {
  commit('setScore', value);
};

export const addScore = ({ commit }, value) => {
  commit('addScore', value);
};

export const resetScore = ({ commit }) => {
  commit('resetScore');
};

export const upLife = ({ commit }, value) => {
  commit('upLife', value);
};

export const downLife = ({ commit }, value) => {
  commit('downLife', value);
};

export const resetLife = ({ commit }, value) => {
  commit('resetLife', value);
};
